<template>
    
    <div class="row">

        
        <div class="col-md-12"  v-if="products.length === 0" >
            <div class="col-12">
                
                <div class="alert_msg">Please add items to compare list</div>

            </div>

        </div>


        <div class="col-md-12" v-if="products.length">
            <div class="table_header">
                <div class="table_header_box for_desktop">Compare</div>
                <div class="table_header_box">Shape</div>
                <div class="table_header_box">Carat</div>
                <div class="table_header_box">Color</div>
                <div class="table_header_box">Clarity</div>
                <div class="table_header_box">Cut</div>
                <div class="table_header_box for_desktop">Report</div>
                <div class="table_header_box">Price</div>
                <!-- <div class="table_header_box for_desktop"></div> -->
            </div>
        </div>
        <div class="col-md-12"  v-show="!showSkeleton">

            <template  v-for="data in products" :key="data.slug">

                <div class="diamond_table" :style="{ transitionDelay: `${data.transitionDelayKey * 50}ms` }">
                  
                    <div class="diamond_table_box_mod for_desktop_mod">
                        <div class="checkbox_custom tooltip_box ml-0" @click="addToCompare(data)">
                            <span :class="{ 'checked' : data.is_compared_count === 1,  'unchecked' : data.is_compared_count === 0 }"></span>
                            <label class="mb-0"></label>
                            <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare</div>
                            <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove from Compare</div>
                        </div>
                    </div>
                    <NuxtLink :to="localePath(detailPath(data.slug))">
                        <div class="diamond_table_flex">
                            <div class="diamond_table_box diamond_table_box_shape">
                                <div class="shape_mod">
                                    <ShapeSvg :type="data.shape_one" class="mr-2 for_desktop" />
                                    <span>{{data.shape_one}}</span>
                                </div>
                                <!-- <div class="shape_mod">
                                    <ShapeSvg :type="data.shape_two" class="mr-2 for_desktop" />
                                    <span>{{data.shape_two}}</span>
                                </div> -->
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.carat_one}} Ct</span>
                                <span>{{data.carat_two}} Ct</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.color_one}}</span>
                                <span>{{data.color_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.clarity_one}}</span>
                                <span>{{data.clarity_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.cut_grade_one}}</span>
                                <span>{{data.cut_grade_two}}</span>
                            </div>
                            <div class="diamond_table_box for_desktop">
                                <span>{{data.report_one}}</span>
                                <span>{{data.report_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{$formatPrice(data.price_one)}}</span>
                                <span>{{$formatPrice(data.price_two)}}</span>
                            </div>
                        </div>
                    </NuxtLink>
                  <!--   <div class="diamond_table_box_mod d-flex justify-content-center for_desktop">
                        <div v-if="data.is_wishlist"><HeaderSvg :type="'wishlist-fill'" /></div>
                        <div v-else><HeaderSvg :type="'wishlist'" /></div>
                    </div> -->
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { cyolistStore } from '~/stores/cyolist/cyolist';
import { compareStore } from '~/stores/diamond_compare/diamond_compare';

const { $toast, $looseViewGtag } = useNuxtApp()
const localePath = useLocalePath()
const storeCyolist = cyolistStore()
const storeCompare = compareStore()

const route = useRoute()

const moduleSubType = route.meta.moduleSubType


const showSkeleton = ref(true)

const products = computed(()=>{
    return storeCyolist.getDiamondCompareListItems()
})

const triggerGtag = (data) => {
    if (moduleSubType === 'loose') {
        $looseViewGtag(data)
    }
}


const detailPath = (slug)=> {
    triggerGtag()
    if ( ['ring','earring','pendant'].includes(moduleSubType)) {

        return  { name: 'cyo-diamond-detail-'+moduleSubType, params:{ slug: slug } }
    }

    return  { name: 'loose-detail', params:{ slug: slug } }
}

const addToCompare = async (diamond)=>{
    storeCompare.addToCompare({ moduleSubType: moduleSubType, diamond: diamond })
    .then( (res) => {
        $toast('success', res.status, res.msg);
    })
}

onMounted(() => {
    storeCyolist.setDiamondCompareListItems({ moduleSubType: moduleSubType }).then(() => showSkeleton.value = false)
})


    
</script>

<style scoped>
.alert_msg {
    text-align: center;
    text-decoration: underline;
    text-transform: capitalize;
}
.shape_mod {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.diamond_table_box span {
    display: block;
    padding: 3px 0;
}
.table_header {
    display: flex;
    align-items: center;
    background: #e2e2e2;
}
/* .table_header_box:first-child, .table_header_box:last-child {
    width: 8%;
} */
.table_header_box {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 12.8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
    text-align: center;
}
.table_header_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
}
.table_header_box:last-child {
    border: 0;
}

/* --------------- */

.diamond_table {
    display: flex;
    align-items: center;
    height: auto;
    border-bottom: 1px solid #e7eaee;
}
.diamond_table_box {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
    width: 14.28%;
    padding: 5px 18px;
    text-transform: capitalize;
    text-align: center;
}

.diamond_table:nth-child(odd) {
  background: #f9f9f9;
}
.diamond_table:nth-child(even) {
  background: #fff;
}
.diamond_table_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 12.5%;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.diamond_table a {
    width: 87.4%;
    display: inline-block;
}
.diamond_table_flex {
    width: 100%;
    display: flex;
    align-items: center;
}

@media(max-width: 1024px){
    .for_desktop_mod{
        display: none;
    }
    .table_header_box, .diamond_table_box{
        width: 16.66%;
        padding: 5px 6px;
    }
    .diamond_table a{
        width: 100%;
    }
}
@media(max-width: 767px){
    .col-md-12 {
        padding: 0;
    }
}

</style>
